module.exports = __webpack_public_path__ + "img/_3.8360a011.png";